module.exports = __webpack_public_path__ + "static/media/Untitled-3.058d89a1.png";